/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardTypeEntity,
    CardTypeEntityFromJSON,
    CardTypeEntityFromJSONTyped,
    CardTypeEntityToJSON,
} from './CardTypeEntity';
import {
    ExportJobEntity,
    ExportJobEntityFromJSON,
    ExportJobEntityFromJSONTyped,
    ExportJobEntityToJSON,
} from './ExportJobEntity';
import {
    ExportStatusEntity,
    ExportStatusEntityFromJSON,
    ExportStatusEntityFromJSONTyped,
    ExportStatusEntityToJSON,
} from './ExportStatusEntity';
import {
    PersonEntity,
    PersonEntityFromJSON,
    PersonEntityFromJSONTyped,
    PersonEntityToJSON,
} from './PersonEntity';
import {
    TransactionEntity,
    TransactionEntityFromJSON,
    TransactionEntityFromJSONTyped,
    TransactionEntityToJSON,
} from './TransactionEntity';

/**
 * 
 * @export
 * @interface CardEntity
 */
export interface CardEntity {
    /**
     * 
     * @type {string}
     * @memberof CardEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CardEntity
     */
    cardSystemId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CardEntity
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CardEntity
     */
    preliminaryCardDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CardEntity
     */
    preliminaryCardRegistrationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CardEntity
     */
    finalCardDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CardEntity
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CardEntity
     */
    cardId?: string;
    /**
     * 
     * @type {string}
     * @memberof CardEntity
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof CardEntity
     */
    registeringCareProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CardEntity
     */
    cardRegistrationReason?: string;
    /**
     * 
     * @type {CardTypeEntity}
     * @memberof CardEntity
     */
    cardTypeEntity?: CardTypeEntity;
    /**
     * 
     * @type {Set<ExportJobEntity>}
     * @memberof CardEntity
     */
    exportJobEntity?: Set<ExportJobEntity>;
    /**
     * 
     * @type {Set<ExportStatusEntity>}
     * @memberof CardEntity
     */
    exportStatusEntities?: Set<ExportStatusEntity>;
    /**
     * 
     * @type {Set<PersonEntity>}
     * @memberof CardEntity
     */
    personsEntities?: Set<PersonEntity>;
    /**
     * 
     * @type {Array<TransactionEntity>}
     * @memberof CardEntity
     */
    transactions?: Array<TransactionEntity>;
}

export function CardEntityFromJSON(json: any): CardEntity {
    return CardEntityFromJSONTyped(json, false);
}

export function CardEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cardSystemId': !exists(json, 'cardSystemId') ? undefined : json['cardSystemId'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'preliminaryCardDate': !exists(json, 'preliminaryCardDate') ? undefined : (new Date(json['preliminaryCardDate'])),
        'preliminaryCardRegistrationDate': !exists(json, 'preliminaryCardRegistrationDate') ? undefined : (new Date(json['preliminaryCardRegistrationDate'])),
        'finalCardDate': !exists(json, 'finalCardDate') ? undefined : (new Date(json['finalCardDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'cardId': !exists(json, 'cardId') ? undefined : json['cardId'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'registeringCareProviderId': !exists(json, 'registeringCareProviderId') ? undefined : json['registeringCareProviderId'],
        'cardRegistrationReason': !exists(json, 'cardRegistrationReason') ? undefined : json['cardRegistrationReason'],
        'cardTypeEntity': !exists(json, 'cardTypeEntity') ? undefined : CardTypeEntityFromJSON(json['cardTypeEntity']),
        'exportJobEntity': !exists(json, 'exportJobEntity') ? undefined : (new Set((json['exportJobEntity'] as Array<any>).map(ExportJobEntityFromJSON))),
        'exportStatusEntities': !exists(json, 'exportStatusEntities') ? undefined : (new Set((json['exportStatusEntities'] as Array<any>).map(ExportStatusEntityFromJSON))),
        'personsEntities': !exists(json, 'personsEntities') ? undefined : (new Set((json['personsEntities'] as Array<any>).map(PersonEntityFromJSON))),
        'transactions': !exists(json, 'transactions') ? undefined : ((json['transactions'] as Array<any>).map(TransactionEntityFromJSON)),
    };
}

export function CardEntityToJSON(value?: CardEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cardSystemId': value.cardSystemId,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString().substr(0,10)),
        'preliminaryCardDate': value.preliminaryCardDate === undefined ? undefined : (value.preliminaryCardDate.toISOString().substr(0,10)),
        'preliminaryCardRegistrationDate': value.preliminaryCardRegistrationDate === undefined ? undefined : (value.preliminaryCardRegistrationDate.toISOString()),
        'finalCardDate': value.finalCardDate === undefined ? undefined : (value.finalCardDate.toISOString().substr(0,10)),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString().substr(0,10)),
        'cardId': value.cardId,
        'carePrincipalId': value.carePrincipalId,
        'registeringCareProviderId': value.registeringCareProviderId,
        'cardRegistrationReason': value.cardRegistrationReason,
        'cardTypeEntity': CardTypeEntityToJSON(value.cardTypeEntity),
        'exportJobEntity': value.exportJobEntity === undefined ? undefined : (Array.from(value.exportJobEntity as Set<any>).map(ExportJobEntityToJSON)),
        'exportStatusEntities': value.exportStatusEntities === undefined ? undefined : (Array.from(value.exportStatusEntities as Set<any>).map(ExportStatusEntityToJSON)),
        'personsEntities': value.personsEntities === undefined ? undefined : (Array.from(value.personsEntities as Set<any>).map(PersonEntityToJSON)),
        'transactions': value.transactions === undefined ? undefined : ((value.transactions as Array<any>).map(TransactionEntityToJSON)),
    };
}

